export const environment = {
  production: false,
  apiUrl: 'https://dev.nowaccount.com/',
  //apiUrl: 'https://localhost:44309/',
};
